import styles from './BurgerNavBar.module.css'
import MainNavStyles from '../MainNav/MainNav.module.css'

import { useState } from 'react'

import { ClickAwayListener } from '@mui/material'

function BurgerNavBar({ NavBarLinks, handleLanguage, userInfos, FrSelect, GbSelect }) {
  const [isChecked, setIsChecked] = useState(false)

  const handleCheckboxToggle = () => {
    setIsChecked((prevState) => !prevState)
  }
  const handleCheckboxClose = () => {
    setIsChecked(false)
  }

  return (
    <ClickAwayListener onClickAway={handleCheckboxClose} >
      <div className={styles.navbar}>
        <div className={styles.navContainer}>
          <input className={styles.checkbox} type='checkbox' checked={isChecked} onChange={handleCheckboxToggle} />
          <div className={styles.hamburgerLines}>
            <span className={`${styles.line} ${styles.line1}`} />
            <span className={`${styles.line} ${styles.line2}`} />
            <span className={`${styles.line} ${styles.line3}`} />
          </div>
          <aside className={styles.menuItems} data-testid='burger-aside'>
            <div className={styles.selectLanguage}>
              <ul>
                <li>
                  <button
                    className={userInfos.language === 'fr' ? styles.languageButtonIsActive : ''}
                    onClick={(e) => {
                      handleLanguage(e, 'fr')
                    }}
                    data-testid='fr-language-button-inBurger'
                  >
                    <FrSelect />
                  </button>
                </li>
                <li>
                  <button
                    className={userInfos.language === 'en' ? styles.languageButtonIsActive : ''}
                    onClick={(e) => {
                      handleLanguage(e, 'en')
                    }}
                    data-testid='en-language-button-inBurger'
                  >
                    <GbSelect />
                  </button>
                </li>
              </ul>
            </div>
            <div className={MainNavStyles.sidenavInnerScroll} onClick={handleCheckboxClose}>
                <ul className={MainNavStyles.sidenavTopLevelItems}>
                  <NavBarLinks navBarLinks={MainNavStyles.navBarLinks} navBarLinkActive={MainNavStyles.navBarLinkActive} />
                </ul>
            </div>
          </aside>
        </div>
      </div>
    </ClickAwayListener>
  )
}
export default BurgerNavBar
